export default "__VITE_ASSET__BUVs0FXF__"